import React from "react";
import { t } from "../../locales/translate";
import { useLocation } from "react-router-dom";

function useLang() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const lang = params.get("lang");
  const supported = ["en", "ja", "ne", "zh", "ko"];
  return supported.includes(lang) ? lang : "en";
}

const InfoComponent = () => {
  const lang = useLang();

  const footerCardStyle = {
    background: "var(--sa-bg-primary)",
    borderRadius: "var(--ShresthaApp-border-radius)",
    boxShadow: "var(--sa-card-shadow)",
    transition: "box-shadow 0.3s, transform 0.2s, background-color 0.3s ease",
    position: "relative",
    zIndex: 1,
    willChange: "transform",
    marginBottom: "100px",
    marginLeft: "16px",
    marginRight: "16px",
    marginTop: "24px",
    paddingTop: "24px",
    width: "100%",
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
      <footer style={footerCardStyle}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 16,
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                borderRadius: "50%",
                width: 64,
                height: 64,
                background: "linear-gradient(135deg, #3B82F6 0%, #1E40AF 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  borderRadius: "50%",
                  width: 64,
                  height: 64,
                  background:
                    "linear-gradient(135deg, #3B82F6 0%, #1E40AF 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                  marginBottom: 8,
                }}
              >
                <span style={{ fontSize: 24, fontWeight: 700 }}>SA</span>
              </div>
            </div>
            <h5
              style={{
                fontWeight: 500,
                color: "var(--sa-text-primary)",
                textAlign: "center",
                marginBottom: -5,
                marginTop: 8,
                transition: "color 0.3s ease",
              }}
            >
              Shrestha Apps
            </h5>
            <p
              style={{
                fontSize: 14,
                color: "var(--sa-text-tertiary)",
                textAlign: "center",
                marginTop: 8,
                transition: "color 0.3s ease",
              }}
            >
              {t(lang, ["footer", "tagline"])}
            </p>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
              marginBottom: 0,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                marginBottom: -5,
              }}
            >
              <span
                style={{
                  color: "var(--sa-text-secondary)",
                  transition: "color 0.3s ease",
                }}
              >
                <span style={{ fontSize: 14, margin: "0 5px" }}>🇳🇵</span>
                {t(lang, ["footer", "nepal"])} |
                <span style={{ fontSize: 14, margin: "0 5px" }}>🇯🇵</span>
                {t(lang, ["footer", "japan"])} |
                <span style={{ fontSize: 14, margin: "0 5px" }}>🇺🇸</span>
                {t(lang, ["footer", "usa"])}
              </span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
              <span
                role="img"
                aria-label="mail"
                style={{
                  color: "var(--sa-text-tertiary)",
                  fontSize: 20,
                  transition: "color 0.3s ease",
                }}
              >
                📧
              </span>
              <span
                style={{
                  color: "var(--sa-text-secondary)",
                  marginRight: 4,
                  transition: "color 0.3s ease",
                }}
              >
                {t(lang, ["footer", "email"])}
              </span>
              <span
                style={{
                  color: "var(--sa-text-secondary)",
                  transition: "color 0.3s ease",
                }}
              >
                shrestha.applications@gmail.com
              </span>
            </div>
          </div>
        </div>
        <div
          style={{
            marginTop: 8,
            paddingTop: 8,
            borderTop: "1px solid var(--sa-border-color)",
            textAlign: "center",
            fontSize: 14,
            color: "var(--sa-text-tertiary)",
            transition: "border-color 0.3s ease, color 0.3s ease",
          }}
        >
          <p>
            {t(lang, ["footer", "copyright"]).replace(
              "{year}",
              new Date().getFullYear()
            )}{" "}
            || {t(lang, ["footer", "allRightsReserved"])}
          </p>
        </div>
      </footer>
    </div>
  );
};

export default InfoComponent;
